import { render, staticRenderFns } from "./MarketplaceLeadsList.vue?vue&type=template&id=2854ff8e&scoped=true&"
import script from "./MarketplaceLeadsList.vue?vue&type=script&lang=js&"
export * from "./MarketplaceLeadsList.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceLeadsList.vue?vue&type=style&index=0&id=2854ff8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2854ff8e",
  null
  
)

export default component.exports